module.exports = __webpack_public_path__ + "img/Hero.ca5141c8.png";